function copyed (txt) {
    navigator.clipboard.writeText(txt)
    console.log('copy');
}

export default copyed
